import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import useFirebase from "../../../../../useFirebase";
import useVideoSettings from "./useVideoSettings";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";

const VideoSettings = ({ deviceSelected, getLangTranslation }) => {
  const [videoSettingData, setVideoSettingData] = useState(null);
  const history = useHistory();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const dispatch = useDispatch();

  const { getCollectionData } = useFirebase(deviceSelected);

  const {
    handleToggleChange,
    handleClear,
    handleApply,
    handleInputChange,
    handleClearOneKeyword,
  } = useVideoSettings(deviceSelected, videoSettingData, setVideoSettingData);

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      setVideoSettingData(setRulesData?.videomonitoring);
    } else {
      setVideoSettingData(null);
    }
  }, [setRulesData]);


  if (!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
      </div>
    )
  }

  return (
    <>
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        <div>
          {getLangTranslation("YOUTUBE_MONITORING_DESCRIPTION_1", "By enabling this feature, you will be able to monitor all videos seen by your child on YouTube")}
          <p className="text-small mb-0">
            {getLangTranslation("YOUTUBE_MONITORING_DESCRIPTION_3", "You can also block some videos by keywords use comma between keywords")}
          </p>
        </div>
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>
      <div
        className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        <p className="text-small mb-0">
          {getLangTranslation("YOUTUBE_MONITORING_DESCRIPTION_2", "Please note that the YouTube app cannot be monitored. We can only monitor videos for YouTube on Chrome, and only keywords searched on YouTube app but we cannot monitor videos or watched. We highly recommend to parents to uninstall or disable YouTube app on child's device and allow him to use YouTube on Chrome where we can monitor all. If uninstall is not possible, please disable the YouTube app, then block the access to settings on child's device (Main menu > Device settings)")}
        </p>
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>

      <div className="form-check form-switch mb-6">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="VIDEO_MONITORING_ENABLED"
          name="VIDEO_MONITORING_ENABLED"
          checked={videoSettingData?.videoMonitoringEnabled}
          onChange={handleToggleChange}
        />
        <label className="form-check-label text-blue-800 fw-semibold" htmlFor="activate">
          {getLangTranslation("CALL_AND_SMS_FEATURE_ACTIVATE_LABEL", "Activate")}
        </label>
      </div>

      {videoSettingData?.videoMonitoringEnabled && (
        <>
          <div className="row align-items-end g-3 mb-6">
            <div className="col-auto flex-grow-1">
              <div className="form-group">
                <label htmlFor="add" className="mb-3 text-dark">
                  {getLangTranslation("KEYSTROKE_MONITORING_ADD_KEYWORDS", "Add keywords that needs to be flagged")}:
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="add"
                  placeholder="Enter keywords to be flagged separated by a comma"
                  value={videoSettingData?.keywordData || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-primary" onClick={handleApply}>
                <span className="btn-upper-case">
                  {getLangTranslation("APPLY", "Apply")}
                </span>
              </button>
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-primary" onClick={handleClear}>
                <span className="btn-upper-case">
                  {getLangTranslation("PARENT_NOTIFICATION_FILTER_CLEAR_ALL", "CLEAR ALL")}
                </span>
              </button>
            </div>
          </div>
          <div className="d-inline-flex flex-wrap gap-3 mb-6">
            {videoSettingData?.videoKeywords?.map((item, index) => (
              <div className="custom-tag" key={index}>
                {item}
                <i className="icon-cancel ms-1 pt-cursor" onClick={() => handleClearOneKeyword(item)} />
              </div>
            ))}
          </div>
        </>
      )}

    </>
  );
};

export default VideoSettings;
